import newPassword from './newPassword'

export default {
  newPassword,
}
